'use client';

import { useDarkMode } from '@/lib/platform/contexts/dark-mode-context';

type ValuationStatus = 'draft' | 'approved';

interface StatusChipProps {
  status: ValuationStatus;
  className?: string;
}

export function StatusChip({ status, className = '' }: StatusChipProps) {
  const { darkMode } = useDarkMode();

  const isDraft = status === 'draft';

  // Color configuration - text is always neutral, only dot is colored
  const textColor = darkMode ? 'text-white' : 'text-gray-900';
  const dotColor = isDraft ? 'fill-gray-500' : 'fill-green-500';

  return (
    <span
      className={`inline-flex shrink-0 items-center gap-x-1.5 text-xs leading-none font-medium capitalize ${textColor} ${className}`}
    >
      <svg viewBox="0 0 6 6" aria-hidden="true" className={`size-1.5 ${dotColor}`}>
        <circle r={3} cx={3} cy={3} />
      </svg>
      {status}
    </span>
  );
}
